export var LoginResponse;
(function (LoginResponse) {
    LoginResponse[LoginResponse["Unauthenticated"] = 0] = "Unauthenticated";
    LoginResponse[LoginResponse["Reconnect"] = 1] = "Reconnect";
    LoginResponse[LoginResponse["Success"] = 2] = "Success";
})(LoginResponse || (LoginResponse = {}));
